import Checkbox from '~/components/widgets/Checkbox/Checkbox';
import EditorLabel from '../EditorLabel/EditorLabel';
import './EditorCheckbox.css';

interface EditorCheckboxProps {
  name: string;
  value: boolean;
  onChange: (val: boolean) => void;
  label: string;
}

export default function EditorCheckbox({
  name,
  value,
  onChange,
  label
}: EditorCheckboxProps) {
  return (
    <div className="EditorCheckbox">
      <Checkbox name={name} value={value} onChange={onChange} />
      <EditorLabel label={label} htmlFor={name} flex />
    </div>
  );
}
